<template>
  <v-dialog
    :model-value="modelValue"
    v-bind="$attrs"
    max-width="60rem"
    scrollable
    @update:model-value="$emit('update:model-value', $event)"
  >
    <v-card>
      <v-card-title />
      <v-card-text>
        <printable-po-preview v-if="isAlive" v-bind="$attrs" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <qtm-btn
          v-bind="closeBtnAttrs"
          class="ml-3"
          tertiary
          @click="$emit('update:model-value', false)"
        >
          {{ closeBtnText }}
        </qtm-btn>
        <span class="ml-3">
          <slot />
        </span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import PrintablePoPreview from '@/components/purchase-orders/printable-po-preview.vue'

export interface Props {
  closeBtnOptions?: object,
  closeBtnText?: string,
  modelValue: boolean,
  refreshOnOpen?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
  closeBtnOptions: undefined,
  closeBtnText: 'Close'
})

defineEmits(['update:model-value'])

const closeBtnAttrs = computed(() => ({ ...props.closeBtnOptions }))
const isAlive = computed(() => (!props.refreshOnOpen || props.modelValue))

</script>
